import { CalendarDate } from "./calendar-date";
export class Invoice {
    constructor() {
        this.tenantId = null;
        this.amountCents = null;
        this.serial = "";
        this.status = "";
        this.notes = null;
        this.invoicePayableName = null;
        this.invoicePayableAddress = null;
        this.invoicePayableCity = null;
        this.invoicePayableState = null;
        this.invoicePayableZip = null;
        this.invoicePayablePhone = null;
        this.invoicePayableEmail = null;
        this.invoicePayableNotes = null;
        this.updatedBy = "";
        this.createdBy = "";
        this.paidDate = null;
        this.sentDate = null;
        this.dueDate = null;
        this.fileId = "";
        this.dateAdded = new Date();
        this.updatedAt = new Date();
        this.deletedAt = null;
    }
    static clone(source) {
        const result = new Invoice();
        result.id = source.id;
        result.tenantId = source.tenantId;
        result.amountCents = source.amountCents;
        result.serial = source.serial;
        result.status = source.status;
        result.notes = source.notes;
        result.invoicePayableName = source.invoicePayableName;
        result.invoicePayableAddress = source.invoicePayableAddress;
        result.invoicePayableCity = source.invoicePayableCity;
        result.invoicePayableState = source.invoicePayableState;
        result.invoicePayableZip = source.invoicePayableZip;
        result.invoicePayablePhone = source.invoicePayablePhone;
        result.invoicePayableEmail = source.invoicePayableEmail;
        result.invoicePayableNotes = source.invoicePayableNotes;
        result.updatedBy = source.updatedBy;
        result.createdBy = source.createdBy;
        result.paidDate = source.paidDate
            ? CalendarDate.parse(source.paidDate).getOrElse(null)
            : null;
        result.sentDate = source.sentDate
            ? CalendarDate.parse(source.sentDate).getOrElse(null)
            : null;
        result.dueDate = source.dueDate
            ? CalendarDate.parse(source.dueDate).getOrElse(null)
            : null;
        result.fileId = source.fileId;
        result.dateAdded = source.dateAdded;
        result.updatedAt = source.updatedAt;
        result.deletedAt = source.deletedAt;
        return result;
    }
    static Load(source) {
        const result = new Invoice();
        result.id = source.id;
        result.tenantId = source.tenantId;
        result.amountCents = source.amountCents;
        result.serial = source.serial;
        result.status = source.status;
        result.notes = source.notes;
        result.invoicePayableName = source.invoicePayableName;
        result.invoicePayableAddress = source.invoicePayableAddress;
        result.invoicePayableCity = source.invoicePayableCity;
        result.invoicePayableState = source.invoicePayableState;
        result.invoicePayableZip = source.invoicePayableZip;
        result.invoicePayablePhone = source.invoicePayablePhone;
        result.updatedBy = source.updatedBy;
        result.createdBy = source.createdBy;
        result.paidDate = source.paidDate
            ? CalendarDate.parse(source.paidDate).getOrElse(null)
            : null;
        result.sentDate = source.sentDate
            ? CalendarDate.parse(source.sentDate).getOrElse(null)
            : null;
        result.dueDate = source.dueDate
            ? CalendarDate.parse(source.dueDate).getOrElse(null)
            : null;
        result.fileId = source.fileId;
        result.dateAdded = source.dateAdded;
        result.updatedAt = source.updatedAt;
        result.deletedAt = source.deletedAt;
        return result;
    }
}
export const QUICKBOOKS_RECIPIENT_MAX_LENGTH = 100;
export const quickBooksRecipientListLength = (recipients) => encodeURIComponent(recipients.join(",")).length;
export const quickBooksRecipientListExceedsLimit = (recipients) => quickBooksRecipientListLength(recipients) > QUICKBOOKS_RECIPIENT_MAX_LENGTH;
export const InvoiceStatuses = ["new", "sent", "paid", "void"];
export const InvoiceStatusLabels = {
    new: "New",
    sent: "Sent",
    paid: "Paid",
    void: "Void",
};
//# sourceMappingURL=invoice.js.map